module.exports = __webpack_public_path__ + "static/media/roxy4.9966b09b.jpg";